import Button from '@ui/Button';
import { cva, cx } from 'cva';
import { isEmpty, isString } from 'lodash-es';
import React from 'react';
import { MdOutlineChevronLeft, MdOutlineChevronRight } from 'react-icons/md';
import VideoPlayer from '@/components/VideoPlayer';
import { Typography } from '@mui/material';

const selectedPostVideos = cva('selectedPostVideos', {
  variants: {
    size: {
      xs: ['h-32'],
      sm: ['h-44'],
      md: ['h-56'],
      lg: ['h-72'],
    },
  },
  defaultVariants: {
    size: 'lg',
  },
});

function SelectedPostVideos(props) {
  const { size, videos } = props;
  const [currentVideoIndex, setCurrentVideoIndex] = React.useState(0);

  const [postVideos, setPostVideos] = React.useState([]);

  const styles = selectedPostVideos({ size });

  React.useEffect(() => {
    if (!isEmpty(videos)) {
      setPostVideos(
        videos.map((video) => {
          if (isString(video)) {
            return {
              url: video,
            };
          }
          return video;
        }),
      );
    } else {
      setPostVideos([]);
    }
  }, [videos]);

  const handleNextClick = () => {
    // slideToNextItem();
    if (currentVideoIndex < postVideos.length - 1) {
      setCurrentVideoIndex(currentVideoIndex + 1);
    }
  };

  const handlePrevClick = () => {
    // slideToPrevItem();
    if (currentVideoIndex > 0) {
      setCurrentVideoIndex(currentVideoIndex - 1);
    }
  };

  if (isEmpty(postVideos)) {
    return null;
  }

  return (
    <div className="relative mt-5 flex w-full flex-1 flex-row items-center justify-start gap-2">
      <div className="absolute left-1 top-1/2">
        <Button
          variant="icon"
          className={cx(
            '!bg-body-background !p-1 opacity-60 hover:opacity-90',
            currentVideoIndex === 0 && 'hidden',
          )}
          onClick={handlePrevClick}>
          <MdOutlineChevronLeft className="h-6 w-6" />
        </Button>
      </div>
      <div className="flex-1 overflow-hidden">
        <div className={cx('flex w-full items-center justify-start', styles)}>
          <VideoPlayer
            src={postVideos[currentVideoIndex].url}
            className="h-full w-full object-contain text-error">
            <Typography variant="subtitle1" color="error">
              The video failed to play. Please choose another one.
            </Typography>
          </VideoPlayer>
        </div>
      </div>
      <div className="absolute right-1 top-1/2">
        <Button
          variant="icon"
          onClick={handleNextClick}
          className={cx(
            '!bg-body-background !p-1 opacity-60 hover:opacity-90',
            currentVideoIndex === postVideos.length - 1 && 'hidden',
          )}>
          <MdOutlineChevronRight className="h-6 w-6" />
        </Button>
      </div>
    </div>
  );
}

export default SelectedPostVideos;
